import React from 'react';
import PropTypes from 'prop-types';
import { OutsWrapper } from '../PlayerDuel.style';
import Outs from '@mlb/react-patterns/components/Outs/outs';

const OutsComponent = ({
    outCount,
    outWidth,
    stroke = true,
    activeColor = 'var(--gameday-outs-color)'
}) => {
    return (
        <OutsWrapper>
            <Outs outCount={ outCount} width={outWidth} outPadding={2.5} outSize={2} outsActiveColor={activeColor} outsInactiveColor='transparent' stroke={stroke} />
        </OutsWrapper>
    );
};

OutsComponent.propTypes = {
    outCount: PropTypes.number,
    outWidth: PropTypes.number,
    stroke: PropTypes.bool,
    activeColor: PropTypes.string
};

export default OutsComponent;
